module.exports = __webpack_public_path__ + "static/media/ramen.b0cd83a9.png";